import { trackEvent, ssrTrackEvent } from '../analytics';
import { tagHJ } from '../analytics/hotjar';
import type { ABTest } from '../enabled_features/types';

/**
 * Fire tracking event for AB test with selected variation.
 * Tag hotjar if tag name exists for test variation.
 * @param abTest
 * @param selectedVariationId - The variation ID, it's number, most of the time, it's also equal to variation index
 */
export const trackABTestVariation = async (abTest: ABTest, selectedVariationId: number | boolean): Promise<void> => {
  // Fire trackevent if event name exists.
  if (abTest.eventName) {
    await trackEvent(abTest.eventName, {
      eventMetadata: { variation: selectedVariationId },
    });
  }

  // Tag hotjar recording if tag name exists for variation.
  await tagHJ(`${abTest.eventName}_${selectedVariationId}`);
};

/**
 * To fire event for AB test during SSR. Provide local user ID if available.
 */
export const ssrTrackABTestVariation = async (
  abTest: ABTest,
  selectedVariationId: number | boolean,
  { userID, sessionID }: { userID?: string; sessionID?: string } = {}
): Promise<void> => {
  console.log('ssrTrackABTestVariation', abTest, selectedVariationId, userID, sessionID);
  if (abTest.eventName) {
    await ssrTrackEvent(abTest.eventName, {
      eventMetadata: { variation: selectedVariationId },
      userID,
      sessionID,
    });
  }
};

/**
 * Fire tracking event for AB test with it's Rollout
 * @param abTest abTest
 */
export const trackABTestOn = async (abTest: ABTest): Promise<void> => {
  if (abTest.eventName) {
    await trackEvent(abTest.eventName, {
      eventMetadata: { on: true },
    });
    if (typeof window !== 'undefined') {
      await tagHJ(`${abTest.eventName}_on`);
    }
  }
};
